import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordRumPageView } from "./rum";

/**
 * Records route changes as page views in AWS RUM when using React Router.
 * Render once inside your Router (e.g. in index.tsx or App.tsx).
 */
export function RumPageViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    recordRumPageView(pathname);
  }, [pathname]);

  return null;
}
